import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import Slider from "react-slick";
import Footer from '../layout/Footer';
import { long as Logo } from '../parts/logo.jsx';
import MailHover from '../parts/MailHover';
import { InformationNewsletterForm as NewsletterForm } from '../parts/NewsletterForm';
import pressItems from '../../../../static/press-items';

const Column = props => (
  <div className={classNames('column', props.className)}>
    {props.children}
  </div>
)

const Section = props => (
  <section className={classNames('section', props.className)}>
    <div className="section__name">
      {props.name}
    </div>
    <div className="section__columns">
      {props.children}
    </div>
  </section>
)

const Detail = props => (
  <div className={classNames('detail', props.className, {'detail--mobile-full': props.mobileFullWidth})}>
    {props.label &&
      <div className="detail__label">
        {props.label}
      </div>
    }
    {props.children &&
      <div className="detail__content">
        {props.children}
      </div>
    }
  </div>
)

const InformationAnimation = () => {
  const animationEl = useRef();
  const [ opacity, setOpacity ] = useState(1);

  useEffect(() => {
    window.addEventListener('scroll', _checkScroll);

    return function cleanup(){
      window.removeEventListener('scroll', _checkScroll);
    }
  }, [])

  const _checkScroll = e => {
    const elementHeight = animationEl.current.clientHeight;
    const thresholdModifier = .7;

    const threshold = elementHeight * thresholdModifier;

    setOpacity((threshold - window.scrollY) / threshold);
  }

  const settings = {
      dots: false,
      fade: true,
      infinite: false,
      arrows: false,
      speed: 1000,
      autoplaySpeed: 2500,
      autoplay: true,
      slidesToShow: 1,
      pauseOnHover: false,
      slidesToScroll: 1
    };

  return (
    <div className="information__animation" ref={animationEl} style={{opacity}}>
      <div className="animation">
        <Slider {...settings}>
          <div className="slide">
            <Logo />
          </div>
          <div className="slide">
            Let’s not make this about us.
          </div>
          <div className="slide">
            Because nope, it’s not.
          </div>
          <div className="slide">
            It’s about the love for people.
          </div>
          <div className="slide">
            <Logo />
          </div>
        </Slider>
      </div>
    </div>
  )
}
const InformationBackdrop = ({name}) => {
  return (
    <div className="information__backdrop">
      <img className={classNames('information__backdrop__item', 'information__backdrop__item--publishing', {
        'visible': name === 'publishing'
      })} src="/static/info-publishing.jpg" />
      <video className={classNames('information__backdrop__item', 'information__backdrop__item--production', {
        'visible': name === 'production'
      })} src="/static/info-production.mp4" type="video/mp4" playsInline autoPlay muted loop/>
    </div>
  )
}
const InformationIntroText = props => (
  <Detail className="information-intro">
    AKKURAT Studios acts as an artist-driven <span className="hotspot" onMouseEnter={() => props.onMouseEnter('production')} onMouseLeave={() => props.onMouseLeave()}>production</span> and <span className="hotspot" onMouseEnter={() => props.onMouseEnter('publishing')} onMouseLeave={() => props.onMouseLeave()}>publishing</span> company. We manage award-winning talent coming from a variety of acknowledged constellations. Working side-by-side with premier brands and agencies to create visionary and outstanding projects.
  </Detail>
);
const Information = props => {
  const [ hovered, setHovered ] = useState(false);

  const _handleMouseEnter = hotspot => {
    setHovered(hotspot);
  }
  const _handleMouseLeave = () => setHovered(false);

  return (
    <div className='page page--information transition'>
      <InformationBackdrop name={hovered} />
      <InformationAnimation />
      <div className={classNames('information__content', {
        'hovered': hovered !== false
      })}>
        <Section className="information-mobile">
          <Column>
              <InformationIntroText onMouseEnter={name => _handleMouseEnter(name)} onMouseLeave={() => _handleMouseLeave()}/>
          </Column>
        </Section>
        <Section name="Europe">
          <Column>
            <Detail label="Co-Founder & Managing Director">
              <MailHover to="rocco@akkurat.tv">Rocco Kopecny</MailHover>
            </Detail>
            <Detail label="Co-Founder & Creative Director">
              <MailHover to="andreas@akkurat.tv">Andreas Roth</MailHover>
            </Detail>
            <Detail label="Partner & Executive Producer">
              <MailHover to="dagmar@akkurat.tv">Dagmar Garber</MailHover>
            </Detail>
            <Detail label="Producer">
              <MailHover to="anka@akkurat.tv">Anka Gerbes</MailHover>
            </Detail>
            <Detail label="Marketing">
              <MailHover to="lena@akkurat.tv">Lena Streckert</MailHover>
            </Detail>
            <Detail label="Directors Representation & Sales">
              <MailHover to="anna@akkurat.tv">Anna Deckers</MailHover>
            </Detail>
          </Column>
          <Column className="information-desktop">
            <InformationIntroText onMouseEnter={name => _handleMouseEnter(name)} onMouseLeave={() => _handleMouseLeave()} />
          </Column>
        </Section>
        <Section name="US">
          <Column>
            <Detail label="Producer">
              <MailHover to="sven@akkurat.tv">Sven Lund</MailHover>
            </Detail>
            <Detail label="Public Relations (worldwide)">
              <MailHover to="carrie@carriewick.com">Carrie Wick</MailHover>
            </Detail>
          </Column>
        </Section>
        <Section name="General">
          <Column>
            <Detail label="General Inquiries">
              <MailHover to="hello@akkurat.tv">Office Berlin</MailHover>
            </Detail>
            <Detail label="Socials">
              <a href="https://www.instagram.com/akkurat.studios" target="_blank">Instagram</a> <br />
              <a href="https://www.facebook.com/akkuratstudios" target="_blank">Facebook</a> <br />
              <a href="https://twitter.com/akkuratstudios " target="_blank">Twitter</a> <br />
              <a href="https://www.linkedin.com/company/akkuratstudios" target="_blank">LinkedIn</a> <br />
              <a href="https://www.youtube.com/channel/UCfogmgg6nP-8pvhhzL_1emA" target="_blank">YouTube</a> <br />
              <a href="https://vimeo.com/akkuratstudios" target="_blank">Vimeo</a> <br />
            </Detail>
          </Column>
          <Column>
            <Detail label="Production Office (Europe)">
              <a href="https://goo.gl/maps/xoF7p37Co3GoiEyGA" target="_blank">
                Besselstraße 13 <br />
                10969 Berlin <br />
                Germany <br />
              </a>
            </Detail>
            <Detail label="Production Office (US)">
              <a href="https://goo.gl/maps/Usvg634UzMaoonfm9" target="_blank">
                2121 E 7th Pl <br />
                Los Angeles <br />
                CA 90021
              </a>
            </Detail>
          </Column>
        </Section>

        <Section name="Selected Press">
          <Column className="press">
            {pressItems.map((pressItem, key) => (
              <Detail label={pressItem.title} key={key}>
                <a href={pressItem.url} target="_blank">{pressItem.headline}</a>
              </Detail>
            ))}
          </Column>
        </Section>

        <Section name="Newsletter">
          <Column className="newsletter-column" >
            <NewsletterForm />
          </Column>
        </Section>

        <Section className="credits">
          <Column>
            <Detail mobileFullWidth label={<React.Fragment><span>Design & Development by </span><a href="https://onefortysix.agency/" target="_blank">146 Agency</a></React.Fragment>} />
          </Column>
        </Section>

        <Section>
          <Column>
            <Detail mobileFullWidth label="AKKURAT Studios &copy; 2021"></Detail>
          </Column>
          <Column>
            <Detail mobileFullWidth label={<a href="/imprint.txt" target="_blank">Imprint</a>} />
          </Column>
        </Section>
      </div>
    </div>
  );
}

export default Information;
